import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function EntryCard({ to, label, desc, action, index = 0, image }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link to={to} data-testid={`entry-card-${to.replace("/", "")}`}
        className="hover-lift group block h-full rounded-2xl border border-[rgba(61,50,56,0.1)] bg-[#FFFFFF] hover:border-[rgba(198,137,158,0.4)] overflow-hidden">
        <div className="aspect-[3/4] bg-[#F3E8E2] overflow-hidden relative">
          {image ? (
            <img src={image} alt={label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="font-serif text-6xl text-[rgba(198,137,158,0.25)] group-hover:text-[rgba(198,137,158,0.5)] transition-colors">
                {label.charAt(0)}
              </span>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-[#FFFFFF] via-transparent to-transparent" />
        </div>
        <div className="p-6 sm:p-7">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="font-serif text-2xl text-[#3D3238] group-hover:text-[#C6899E] transition-colors">{label}</h3>
              <p className="mt-2 text-sm text-[#8C7E83] leading-relaxed">{desc}</p>
            </div>
            <div className="mt-1 w-9 h-9 shrink-0 rounded-full border border-[rgba(198,137,158,0.3)] flex items-center justify-center group-hover:bg-[#C6899E] transition-colors">
              <ArrowUpRight className="w-4 h-4 text-[#C6899E] group-hover:text-[#4A2233] transition-colors" />
            </div>
          </div>
          <span className="mt-5 inline-block eyebrow">{action}</span>
        </div>
      </Link>
    </motion.div>
  );
}
